import AttachmentModel from "api/models/AttachmentModel";
import { Transaction, getDocs, query, where } from "firebase/firestore";
import {
  deleteDocument,
  fromDocumentData,
  getCollectionRef,
  getDocumentRef,
  setDocument,
  toDocumentData,
} from "./FirebaseRepository";

class AttachmentRepository {
  private path = (contractUid) => `cfContract/${contractUid}/attachments`;

  public async addAttachmentToDataBase(
    contractUid: string,
    uid: string,
    attachment: AttachmentModel,
    transaction?: Transaction
  ): Promise<void> {
    const collectionPath = this.path(contractUid);
    const doc = getDocumentRef(collectionPath, uid, converter);
    return setDocument(doc, attachment, transaction);
  }

  public async getAttachmentsFromDataBase(
    contractUid: string,
    uids: string[]
  ): Promise<AttachmentModel[]> {
    const collectionPath = this.path(contractUid);
    const collection = getCollectionRef(collectionPath, converter);

    const queryRef = query(collection, where("__name__", "in", uids));
    const snapshot = await getDocs(queryRef);
    return snapshot.docs.map((doc) => converter.fromFirestore(doc, undefined));
  }

  public deleteAttachmentFromDataBase(
    contractUid: string,
    uid: string,
    transaction?: Transaction
  ) {
    const collectionPath = this.path(contractUid);
    const doc = getDocumentRef(collectionPath, uid, converter);
    return deleteDocument(doc, transaction);
  }
}

// Firestore data converter
const converter = {
  toFirestore: (attachment: any) => {
    const data =
      attachment instanceof AttachmentModel ? attachment.toSave() : attachment;
    return toDocumentData(data);
  },
  fromFirestore: (snapshot, options) => {
    let data = snapshot.data(options);
    data = fromDocumentData(data);
    return AttachmentModel.create(snapshot.id, data);
  },
};

export default new AttachmentRepository();
